export function setupGallery(gallery) {
  if (gallery.dataset.initialized) return;
  gallery.dataset.initialized = 'true';
  const track = gallery.querySelector('[data-gallery-track]');
  const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
  const buttons = [...gallery.querySelectorAll('[data-gallery-index]')];
  const select = index => {
    buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
  };
  buttons.forEach((button, index) => button.addEventListener('click', () => {
    slides[index].scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'nearest', inline: 'center' });
    select(index);
  }));
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) if (entry.isIntersecting) select(slides.indexOf(entry.target));
  }, { root: track, threshold: 0.65 });
  slides.forEach(slide => observer.observe(slide));
  track.addEventListener('keydown', event => {
    if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    event.preventDefault();
    const rtl = getComputedStyle(track).direction === 'rtl';
    const current = buttons.findIndex(button => button.getAttribute('aria-pressed') === 'true');
    const next = Math.max(0, Math.min(slides.length - 1, current + ((event.key === 'ArrowRight') !== rtl ? 1 : -1)));
    buttons[next].click();
  });
}
const init = () => document.querySelectorAll('[data-gallery]').forEach(setupGallery);
init();
document.addEventListener('shopify:section:load', init);
